import { Navigate } from "react-router-dom"
import { useAuth } from "./Authcontext"
import { useEffect } from "react"


function checkRoles(allowedRoles , userRoles){

    if(allowedRoles && userRoles && !userRoles.includes(allowedRoles)){
        return false
    }
    return true
    
}
const PrivateRoute = ({ children , allowedRoles }) => {
    const { isAuthenticated , user ,loading} = useAuth()


    if(loading) return null

    const userRoles = user && user.scopes 

    if(!isAuthenticated){
        return <Navigate to="/" />
    }


    if(!checkRoles(allowedRoles , userRoles)){
        return <Navigate to="/unauthorized" /> 
    }

    return children;

}


export default PrivateRoute;